import { useMutation } from '@tanstack/react-query';
import axios from 'axios';
import { environment } from '../config/environment';

const sha256Hex = async (message: string): Promise<string> => {
  const data = new TextEncoder().encode(message);
  const hashBuffer = await crypto.subtle.digest('SHA-256', data);
  return Array.from(new Uint8Array(hashBuffer))
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('');
};

interface UpdateWalletParams {
  formId: string;
  walletId: string;
  workspaceId: string;
  metadata: Record<string, string | boolean | number | string[]>;
}

const updateWallet = async (params: UpdateWalletParams): Promise<void> => {
  const { formId, walletId, workspaceId, metadata } = params;
  const token = await sha256Hex(`${formId}.${walletId}.${workspaceId}`);
  await axios.patch(
    `${environment.API}/forms/${formId}/wallets/${walletId}`,
    { metadata },
    {
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
        'Authorization': `Bearer ${token}`,
      },
    }
  );
};

export const useUpdateWallet = () => {
  return useMutation({
    mutationFn: (params: UpdateWalletParams) => updateWallet(params),
  });
};
